module.exports = __webpack_public_path__ + "static/LatoRegular-2d36b1a925432bae7f3c53a340868c6e.ttf";